/** Which card the thread footer holds, if any. */
export type FooterCard = 'none' | 'assistant' | 'legacy';

/**
 * Which card the footer draws. Keeps the two AI lanes from running at once.
 *
 * `assistantEnabled` null (the switch has not answered) draws the assistant:
 * AI_ASSISTANT_ENABLED_ROLES is role-wide, so the answer is identical for every
 * employer and a wrong guess costs one flash per page load, not a wrong lane.
 * `assistantSilent` (lane on, nothing to show) falls back to the legacy card's
 * naming but not its `awaitingReply` rule, and fires no model call (see
 * `legacyLane` in ChatView).
 */
export function footerCard(
  live: boolean,
  awaitingReply: boolean,
  assistantEnabled: boolean | null,
  assistantSilent = false,
): FooterCard {
  if (!live) return 'none';
  if (assistantEnabled === false) return awaitingReply ? 'legacy' : 'none';
  return assistantSilent ? 'legacy' : 'assistant';
}
